























































































































































import Vue from 'vue'
import AddressPlanningSpecifications from '@/components/master-data/address/AddressPlanningSpecifications.vue'
import { Department } from '@/model/companyStructure/Department'
import {
  AddressProjectSpecificationsAuslieferorte, AddressProjectSpecificationsBonitaeten,
  AddressProjectSpecificationsKonditionenZahlung,
  AddressProjectSpecificationsKontoPlan, AddressProjectSpecificationsLieferung,
  AddressProjectSpecificationsPreisarten,
  AddressProjectSpecificationsProfitCenter,
  AddressProjectSpecificationsResponse,
  AddressProjectSpecificationsSteuersaetze,
  AddressProjectSpecificationsUmsatzart, AddressProjectSpecificationsVersand,
  AddressProjectSpecificationsWaehrungen, AdressVorgaben,
  CompanyStructureForPlanningResponse, ResponseBase
} from '@/types/service-response'
import {
  CREATE_PROJECT_SPECIFICATIONS,
  DELETE_PROJECT_SPECIFICATIONS,
  FETCH_PROJECT_SPECIFICATIONS,
  LOAD_COMPANY_STRUCTURE, UPDATE_PROJECT_SPECIFICATIONS
} from '@/store/action-types'
import { ProfitCenter } from '@/model/companyStructure/ProfitCenter'
import { PlanningGroup } from '@/model/companyStructure/PlanningGroup'
import { Employee } from '@/model/companyStructure/Employee'
import { CompanyStructure, GridOptions } from '@/types'
import { hexToRgba } from '@/services/hex-to-rgba'
import ActiveCellRenderer from '@/components/cell-renderer/ActiveCellRenderer.vue'
import moment from 'moment'
import UniqueCellRenderer from '@/components/cell-renderer/UniqueCellRenderer.vue'
import { TranslateResult } from 'vue-i18n'
import CompetenceQualityCellRenderer from '@/components/cell-renderer/CompetenceQualityCellRenderer.vue'
import _ from 'lodash'
import AddressProjectSpecifications from '@/components/master-data/address/AddressProjectSpecifications.vue'
import { DeleteAdressVorgabenpayload, InsertAdressVorgabenPayload, UpdateAdressVorgabenPayload } from '@/types/payload'
import { KeyActionEnum, SnackbarStateEnum } from '@/types/enums'
import ProgressCircular from '@/components/ProgressCircular.vue'
import { DxColumn, DxDataGrid, DxScrolling, DxSelection } from 'devextreme-vue/data-grid'
import DeleteDialog from '@/components/DeleteDialog.vue'
import { keyActionService } from '@/services/key-action-service'
import { KeyAction } from '@/model/KeyAction'

class Create extends KeyAction {}
class Edit extends KeyAction {}
class Delete extends KeyAction {}

interface DayListItem {
  id: number
  day: TranslateResult
}

interface ComponentData {
  showSnackbar: boolean
  snackbarState: number
  messageSnackbar: TranslateResult | string
  loading: boolean
  dialogLoading: boolean
  planningSpecificationsGridOptions: GridOptions
  gridFrameworkComponents: Object
  overlayNoRowsTemplate: string
  weekDayList: Array<DayListItem>
  planningSpecificationsList: any[]
  projectSpecificationsList: AdressVorgaben[]
  companyStructure: CompanyStructure
  planningSpecificationsTitle: string
  projectSpecificationsTitle: string
  showPlanningSpecificationsDialog: boolean
  showProjectSpecificationsDialog: boolean
  selectedPlanningSpecifications: any
  selectedProjectSpecifications: AdressVorgaben | undefined
  isProjectSpecificationsEdit: boolean

  waehrungList: AddressProjectSpecificationsWaehrungen[]
  kontoPlanList: AddressProjectSpecificationsKontoPlan[]
  steuersaetzeList: AddressProjectSpecificationsSteuersaetze[]
  preisartenList: AddressProjectSpecificationsPreisarten[]
  umsatzartList: AddressProjectSpecificationsUmsatzart[]
  profitCenterList: AddressProjectSpecificationsProfitCenter[]
  konditionenZahlungList: AddressProjectSpecificationsKonditionenZahlung[]
  auslieferorteList: AddressProjectSpecificationsAuslieferorte[]
  bonitaetenList: AddressProjectSpecificationsBonitaeten[]
  versandList: AddressProjectSpecificationsVersand[]
  lieferungList: AddressProjectSpecificationsLieferung[]
  showDeleteDialog: boolean

  keyActions: KeyAction[]
}

export default Vue.extend({
  name: 'AddressRequirements',

  components: {
    AddressPlanningSpecifications,
    AddressProjectSpecifications,
    ProgressCircular,
    DxDataGrid,
    DxColumn,
    DxScrolling,
    DxSelection,
    DeleteDialog
  },

  props: {
    addressId:{
      type: Number,
      default: undefined
    }
  },

  data (): ComponentData {
    return {
      showSnackbar: false,
      snackbarState: 0,
      messageSnackbar: '',
      loading: false,
      dialogLoading: false,
      planningSpecificationsGridOptions: {
        columnDefs: [
          { headerName: this.$t('masterData.shifts.start'), field: 'start', width: 100 },
          { headerName: this.$t('masterData.shifts.end'), field: 'end', width: 100 },
          { headerName: this.$t('masterData.shifts.active'), field: 'isActive', cellRenderer: 'activeRenderer'},
          { headerName: 'Pause(von-bis)', valueGetter: (params: any) => {
              return params.data.start && params.data.end ? `${params.data.start} - ${params.data.end}` : ''
            }
          },
          { headerName: 'Einmalig', field: 'isUnique', cellRenderer: 'uniqueCellRenderer'},
          { headerName: 'Einsatztage', valueGetter: (params: any) => {
              const dayNameList: string[] = params.data.selectedWeekDayList.map((item: number) => {
                // @ts-ignore
                const foundDay: DayListItem | undefined = this.weekDayList.find((i: DayListItem) => i.id === item)
                return foundDay!.day
              })
              return dayNameList.toString()
            }, width: 300
          },
          { headerName: 'Einsatzrhytmus', field: 'repeatEveryNthWeek'},
          { headerName: 'Ausführen bis', valueGetter: (params: any) => {
              return params.data.expireAfterDateIso ? moment(params.data.expireAfterDateIso).format('DD.MM.YYYY') : ''
            }
          },
          { headerName: 'Vereinbarungen', field: 'agreementData[0].quality', cellRenderer: 'qualityCellRenderer',  width: 300}
        ]
      },
      gridFrameworkComponents: {
        activeRenderer: ActiveCellRenderer,
        uniqueCellRenderer: UniqueCellRenderer,
        qualityCellRenderer: CompetenceQualityCellRenderer
      },
      overlayNoRowsTemplate: "<span>"+this.$t('errors.noRowsToShow')+"</span>",
      weekDayList: [
        {day: this.$t('planningPage.monday'), id: 1},
        { day: this.$t('planningPage.tuesday'), id: 2},
        { day: this.$t('planningPage.wednesday'), id: 3},
        { day: this.$t('planningPage.thursday'), id: 4},
        { day: this.$t('planningPage.friday'), id: 5},
        { day: this.$t('planningPage.saturday'), id: 6},
        { day: this.$t('planningPage.sunday'), id: 7},
      ],
      planningSpecificationsList: [],
      projectSpecificationsList: [],
      companyStructure: {
        profitCenterList: [],
        departmentList: [],
        planningGroupList: [],
        employeeList: []
      },
      planningSpecificationsTitle: this.$t('masterData.addresses.addressRequirements.title1').toString(),
      projectSpecificationsTitle: this.$t('masterData.addresses.addressRequirements.title2').toString(),
      showPlanningSpecificationsDialog: false,
      showProjectSpecificationsDialog: false,
      selectedPlanningSpecifications: undefined,
      selectedProjectSpecifications: undefined,
      isProjectSpecificationsEdit: false,

      waehrungList: [],
      kontoPlanList: [],
      steuersaetzeList: [],
      preisartenList: [],
      umsatzartList: [],
      profitCenterList: [],
      konditionenZahlungList: [],
      auslieferorteList: [],
      bonitaetenList: [],
      versandList: [],
      lieferungList: [],
      showDeleteDialog: false,

      keyActions: []
    }
  },

  computed: {
    toolbarColor (): string {
      return hexToRgba(this.$vuetify.theme.themes.light.primary)
    },

    snackbarColor (): boolean {
      return this.snackbarState === SnackbarStateEnum.Success
    },

    isEnablePlanningSpecificationButtons (): boolean {
      return !!this.selectedPlanningSpecifications
    },

    isEnableProjectSpecificationButtons (): boolean {
      return !!this.selectedProjectSpecifications
    },

    departmentList (): Array<Department> {
      /*let list: Array<Department> = []

      if (this.selectedProfitCenterId) {
        list = this.companyStructure.departmentList
            .filter((item: Department) => item.profitCenterId === this.selectedProfitCenterId)
      }*/

      return this.companyStructure.departmentList
    },
  },

  methods: {
    onKeydown (event: any): void {
      const action: any = keyActionService(event, this.keyActions)
      action && action.handle()
    },

    resolver (action: Create | Edit | Delete | null): boolean {
      if(action instanceof Create) {
        return true
      } else if(action instanceof Edit) {
        return this.isEnableProjectSpecificationButtons
      } else if(action instanceof Delete) {
        return this.isEnableProjectSpecificationButtons
      } else {
        return false
      }
    },

    getFormattedExpireAfterDate(item: any): string {
      return item.data.expireAfterDateIso ? moment(item.data.expireAfterDateIso).format('DD.MM.YYYY') : ''
    },

    onAddPlanningSpecificationClick (): void {
      this.planningSpecificationsTitle = this.$t('masterData.addresses.addressRequirements.planningRequirementsAddTitle').toString()
      this.showPlanningSpecificationsDialog = true
    },

    onEditPlanningSpecificationClick (): void {
      this.planningSpecificationsTitle = this.$t('masterData.addresses.addressRequirements.planningRequirementsEditTitle').toString()
      this.showPlanningSpecificationsDialog = true
    },

    onDeletePlanningSpecificationClick (): void {

    },

    onPlanningSpecificationsRowClicked (event: any): void {
      this.selectedPlanningSpecifications = event.data
    },

    planningSpecificationSave (item: any): void {
      const maxId: any = _.maxBy(this.planningSpecificationsList, 'id')
      item.id = maxId ? maxId.id + 1 : 1
      this.planningSpecificationsList.push(item)
      this.selectedPlanningSpecifications = undefined
      this.showPlanningSpecificationsDialog = false
    },

    planningSpecificationClose (): void {
      this.showPlanningSpecificationsDialog = false
    },

    onAddProjectSpecificationClick (): void {
      this.projectSpecificationsTitle = this.$t('masterData.addresses.addressRequirements.projectRequirementsAddTitle').toString()
      this.isProjectSpecificationsEdit = false
      this.showProjectSpecificationsDialog = true
      //@ts-ignore
      this.$refs.dataGrid2.instance.deselectAll()
      this.selectedProjectSpecifications = undefined
    },

    create (action?: KeyAction | null): void {
      if(action) {
        action.event.preventDefault()
      }

      this.onAddProjectSpecificationClick()
    },

    onEditProjectSpecificationClick (): void {
      this.projectSpecificationsTitle = this.$t('masterData.addresses.addressRequirements.projectRequirementsEditTitle').toString()
      this.isProjectSpecificationsEdit = true
      this.showProjectSpecificationsDialog = true
    },

    update (action?: KeyAction | null): void {
      if(action) {
        action.event.preventDefault()
      }

      this.onEditProjectSpecificationClick()
    },

    onDeleteProjectSpecificationClick (): void {
      this.showDeleteDialog = true
    },

    delete (action?: KeyAction | null): void {
      if(action) {
        action.event.preventDefault()
      }

      this.onDeleteProjectSpecificationClick()
    },

    onDeleteDialogClose (): void {
      this.showDeleteDialog = false
    },

    onDeleteDialogSave (): void {
      this.onDeleteProjectSpecification()
    },

    async onDeleteProjectSpecification (): Promise<void> {
      if(this.selectedProjectSpecifications) {
        const payload: DeleteAdressVorgabenpayload = {
          ID: this.selectedProjectSpecifications!.ID
        }

        try {
          this.loading = true
          const response: ResponseBase = await this.$store.dispatch(DELETE_PROJECT_SPECIFICATIONS, payload)
          this.loading = false
          if (!response.IsError) {
            //@ts-ignore
            this.$refs.dataGrid2.instance.deselectAll()
            this.showDeleteDialog = false
            this.selectedProjectSpecifications = undefined
            this.fetchProjectSpecifications()
            this.messageSnackbar = this.$t('success.dataHaveBeenDeleted')
            this.snackbarState = SnackbarStateEnum.Success
            this.showSnackbar = true
          } else {
            this.messageSnackbar = this.$t('errors.dataCouldNotBeDeleted')
            this.snackbarState = SnackbarStateEnum.Error
            this.showSnackbar = true
          }
        } catch {
          this.messageSnackbar = this.$t('errors.dataCouldNotBeDeleted')
          this.snackbarState = SnackbarStateEnum.Error
          this.showSnackbar = true
        }
      }
    },

    onProjectSpecificationsRowClicked (params: any): void {
      this.selectedProjectSpecifications = params.data
    },

    projectSpecificationClose (): void {
      this.showProjectSpecificationsDialog = false
    },

    async createProjectSpecification (payload: InsertAdressVorgabenPayload): Promise<void> {
      try {
        this.dialogLoading = true
        const response: ResponseBase = await this.$store.dispatch(CREATE_PROJECT_SPECIFICATIONS, payload)
        this.dialogLoading = false
        if (!response.IsError) {
          this.showProjectSpecificationsDialog = false
          this.fetchProjectSpecifications()
          this.messageSnackbar = this.$t('success.dataHaveBeenSaved')
          this.snackbarState = SnackbarStateEnum.Success
          this.showSnackbar = true
        } else {
          this.messageSnackbar = this.$t('errors.dataCouldNotBeSaved')
          this.snackbarState = SnackbarStateEnum.Error
          this.showSnackbar = true
        }
      } catch {
        this.messageSnackbar = this.$t('errors.dataCouldNotBeSaved')
        this.snackbarState = SnackbarStateEnum.Error
        this.showSnackbar = true
      }
    },

    async editProjectSpecification (payload: UpdateAdressVorgabenPayload): Promise<void> {
      try {
        this.dialogLoading = true
        const response: ResponseBase = await this.$store.dispatch(UPDATE_PROJECT_SPECIFICATIONS, payload)
        this.dialogLoading = false
        if (!response.IsError) {
          //@ts-ignore
          this.$refs.dataGrid2.instance.deselectAll()
          this.selectedProjectSpecifications = undefined
          this.showProjectSpecificationsDialog = false
          this.fetchProjectSpecifications()
          this.messageSnackbar = this.$t('success.dataHaveBeenSaved')
          this.snackbarState = SnackbarStateEnum.Success
          this.showSnackbar = true
        } else {
          this.messageSnackbar = this.$t('errors.dataCouldNotBeSaved')
          this.snackbarState = SnackbarStateEnum.Error
          this.showSnackbar = true
        }
      } catch {
        this.messageSnackbar = this.$t('errors.dataCouldNotBeSaved')
        this.snackbarState = SnackbarStateEnum.Error
        this.showSnackbar = true
      }
    },

    async fetchProjectSpecifications(): Promise<void> {
      try {
        this.loading = true
        const response: AddressProjectSpecificationsResponse = await this.$store.dispatch(FETCH_PROJECT_SPECIFICATIONS, this.addressId)
        this.loading = false
        if(!response.IsError) {
          this.projectSpecificationsList = response.AdressVorgaben
          this.waehrungList = response.Waehrung
          this.kontoPlanList = response.KontoPlan
          this.steuersaetzeList = response.Steuersaetze
          this.preisartenList = response.Preisarten
          this.umsatzartList = response.Umsatzart
          this.profitCenterList = response.ProfitCenter
          this.konditionenZahlungList = response.KonditionenZahlung
          this.auslieferorteList = response.Auslieferorte
          this.bonitaetenList = response.Bonitaeten
          this.versandList = response.Versand
          this.lieferungList = response.Lieferung
        } else {

        }
      } catch {
        this.loading = false
      }
    }

  },

  beforeMount () {
    this.keyActions = [
      new Create(KeyActionEnum.create, this.create, this.resolver,  null),
      new Edit(KeyActionEnum.edit, this.update, this.resolver, null),
      new Delete(KeyActionEnum.delete, this.delete, this.resolver, null),
    ]
  },

  async mounted () {
    window.addEventListener('keydown', this.onKeydown)
    const responseData: CompanyStructureForPlanningResponse = await this.$store.dispatch(LOAD_COMPANY_STRUCTURE)

    this.companyStructure = {
      profitCenterList: ProfitCenter.createFromResponse(responseData),
      departmentList: Department.createFromResponse(responseData),
      planningGroupList: PlanningGroup.createFromResponse(responseData),
      employeeList: Employee.createFromResponse(responseData)
    }
    this.fetchProjectSpecifications()
  },

  beforeDestroy (): void {
    window.removeEventListener('keydown', this.onKeydown)
  }
})
